export default __webpack_public_path__ + "static/media/people.fb6e3334.svg";